import { ApeironCloseButton } from '@apeiron/temp'
import { Box, Snackbar, styled } from '@mui/material'
import { FC, ReactNode, useCallback, useState } from 'react'
import useLocalStorage from 'use-local-storage'

const Container = styled(Box)`
  background-color: #161522cc;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 10px 40px 10px 20px;
  ${props => props.theme.breakpoints.up('res1024')} {
    max-width: 350px;
  }
  ${props => props.theme.breakpoints.down('res1024')} {
    max-width: 320px;
  }
`

const StyledApeironCloseButton = styled(ApeironCloseButton)`
  position: absolute;
  right: 10px;
  top: 10px;
`

const ApeironSnackNotify: FC<Props> = (props: Props) => {
  const { children, className, notifyKey } = props

  const [defaultOpen, setDefaultOpen] = useLocalStorage(
    `notify_${notifyKey}`,
    true
  )

  const [open, setOpen] = useState<boolean>(defaultOpen)

  const handleOnClose = useCallback(() => {
    setOpen(false)
    setDefaultOpen(false)
  }, [setDefaultOpen])

  return (
    <Snackbar
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      className={className}
      open={open}
      key={notifyKey}
    >
      <Container className='Custom-Container'>
        {children}
        <StyledApeironCloseButton onClick={handleOnClose} />
      </Container>
    </Snackbar>
  )
}

type Props = {
  children?: ReactNode
  className?: string
  notifyKey: string
}

export default ApeironSnackNotify
